"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultNumber = exports.getDefaultString = exports.getDefault = void 0;
/**
 * When values is undefined, the default value is returned
 * @param data - either what will be returned or undefined
 * @param default_value - the back-up value when data is undefined
 * @returns either data or default_value
 */
function getDefault(data, default_value) {
    if (typeof data === 'undefined') {
        return default_value || null;
    }
    return data;
}
exports.getDefault = getDefault;
/**
 * When values is not a string, the default value is returned
 * @param data - either what will be returned or undefined
 * @param default_value - the back-up value when data is not a string
 * @returns either data or default_value
 */
function getDefaultString(data, default_value) {
    if (typeof data !== 'string') {
        return default_value || null;
    }
    return data;
}
exports.getDefaultString = getDefaultString;
/**
 * When values is not a number, the default value is returned
 * @param data - either what will be returned or undefined
 * @param default_value - the back-up value when data is not a number
 * @returns either data or default_value
 */
function getDefaultNumber(data, default_value) {
    if (typeof data !== 'number') {
        return default_value || null;
    }
    return data;
}
exports.getDefaultNumber = getDefaultNumber;
